import { gql } from '@apollo/client';

export const fetchBillingAdminsForTransactionAccount = gql`
  query fetchBillingAdminsForTransactionAccount($id: ID!, $searchOptions: ConnectionSearchOptions) {
    transactionAccount(id: $id) {
      id
      billingAdmins(searchOptions: $searchOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            email
            atlassianAccountId
            fullName
          }
        }
      }
    }
  }
`;
